import { render, staticRenderFns } from "./employeeOvertime.vue?vue&type=template&id=a40c2840"
import script from "./employeeOvertime.vue?vue&type=script&lang=js"
export * from "./employeeOvertime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports